import { Component, ElementRef, ViewChild } from '@angular/core';

import { UtilityService } from '@app/utils/utility.service';
import { environment } from 'src/environments/environment';
import { BusinessProfileService } from '@services/business-profile/business-profile.service';
import { isUsageBasedStripeBilling as profileUsesUsageBasedStripe } from '@app/utils/billing-access';

@Component({
  selector: 'app-welcome-board',
  templateUrl: './welcome-board.component.html'
})
export class WelcomeBoardComponent {
  public document = document;

  readonly developersDocsUrl = `${environment.developersPortalOrigin}/docs`;

  @ViewChild('fileImportInput', { static: false }) fileImportInput: ElementRef<HTMLInputElement>;

  constructor(
    private utility: UtilityService,
    private businessProfileService: BusinessProfileService,
  ) {
  }

  get usesUsageBasedStripeBilling(): boolean {
    return profileUsesUsageBasedStripe(this.businessProfileService.businessProfile);
  }

  async fileChangeListener($event: any): Promise<void> {
    this.utility.validateTransactionsCSVFile($event.srcElement.files[0]).subscribe();
  }

}
